import { gsap } from './animationLibs.js'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default function initTopScrollAnimation() {


	const contentHeaders = document.querySelectorAll('.contentHeader');
	if (!contentHeaders.length) {
		return;
	}

	contentHeaders.forEach(header => {
		const titleEN = header.querySelector('.contentHeader-title-en');
		const icon = header.querySelector('.contentHeader-icon');

		// --- アニメーション設定と初期値の一元化 ---
		const iconInitialState = { y: '20%', scale: 0 };
		const iconAnimState = { y: '0%', scale: 1, duration: 1, ease: 'elastic.out(1, 0.5)', overwrite: true };
		const headerInitialState = { y: '50%', opacity: 0 };
		const headerAnimState = { y: '0%', opacity: 1, duration: 1, ease: 'power2.out' };

		// ヘルパー関数: アイコンアニメーション関連
		const resetIcon = () => {
			gsap.killTweensOf(icon);
			gsap.set(icon, iconInitialState);
		};
		const playIcon = (delay = 0) => {
			gsap.killTweensOf(icon);
			gsap.fromTo(icon, iconInitialState, { ...iconAnimState, delay });
		};

		// 初期状態の適用
		gsap.set(header, headerInitialState);
		resetIcon();

		// proxy オブジェクトを用いてカスタムプロパティを滑らかに更新（ScrollTriggerでスクロールに同期）
		// 初期値（疑似要素が親のカスタムプロパティを参照している想定）
		const initialGlitterProgress = titleEN ? parseFloat(getComputedStyle(titleEN).getPropertyValue('--glitter-mask-progress-all')) || 0 : 0;
		const initialGlitterPositionX = titleEN ? parseFloat(getComputedStyle(titleEN).getPropertyValue('--glitter-positionX')) || 100 : 100;
		const glitterProxy = {
			v: initialGlitterProgress,
			posX: initialGlitterPositionX
		};
		if (titleEN) {
			titleEN.style.setProperty('--glitter-mask-progress-all', initialGlitterProgress);
			titleEN.style.setProperty('--glitter-positionX', `${initialGlitterPositionX}%`);
		}

		// スクラブさせない（スクロールでトリガーして Tween を再生する方式）
		const glitterTween = gsap.to(glitterProxy, {
			v: 1,
			posX: 100,
			duration: 1,
			ease: 'power3.out',
			paused: true,
			onUpdate: () => {
				if (titleEN) {
					titleEN.style.setProperty('--glitter-mask-progress-all', glitterProxy.v);
					titleEN.style.setProperty('--glitter-positionX', `${glitterProxy.posX}%`);
				}
			}
		});

		// リセット用の Tween を保持（競合を避けるため）
		let resetTween = null;

		// ScrollTrigger を作って onEnter/onLeave で Tween を制御（scrub なし）
		ScrollTrigger.create({
			trigger: titleEN,
			start: 'top 100%',
			end: 'top 60%',
			onEnter: () => {
				if (resetTween) { resetTween.kill(); resetTween = null; }
				glitterTween.restart();
				playIcon();
			},
			onLeaveBack: () => {
				// 即座に progress(0) すると proxy の値が一瞬で 0 になってしまうため
				// スムーズに 0 に戻すアニメーションに置き換える。
				console.log('Title left viewport from below');
				if (glitterTween && glitterTween.isActive()) {
					glitterTween.pause();
				}
				if (resetTween) { resetTween.kill(); }
				resetTween = gsap.to(glitterProxy, {
					v: initialGlitterProgress,
					posX: initialGlitterPositionX,
					duration: 0.5,
					ease: 'power3.in',
					onUpdate: () => {
						if (titleEN) {
							titleEN.style.setProperty('--glitter-mask-progress-all', glitterProxy.v);
							titleEN.style.setProperty('--glitter-positionX', `${glitterProxy.posX}%`);
						}
					},
					onComplete: () => { resetTween = null; }
				});
			}
		});

		// iconのリセットは、icon自身が画面下部に完全に消え去った際に行う
		ScrollTrigger.create({
			trigger: icon,
			start: 'top 100%',
			onLeaveBack: resetIcon
		});

		// ページロード時の初期アニメーション分岐
		const rect = header.getBoundingClientRect();
		// 判定を「ページの上部のファーストビュー内」に変更（viewportの上位80%に含まれるか）
		const headerInView = rect.top >= 0 && rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
		if (headerInView) {
			// immediate case: use a smaller initial offset
			gsap.set(header, { y: '10%' });
			gsap.delayedCall(0.5, () => {
				header.classList.add('on-animate');
				gsap.to(header, headerAnimState);
				if (titleEN) glitterTween.restart();
				playIcon(0.3); // delay 0.3 for icon
			});
		} else {
			gsap.to(header, {
				...headerAnimState,
				scrollTrigger: {
					trigger: header,
					start: 'top 100%',
					end: 'top 60%',
					scrub: 0.5,
					onEnter: () => {
						header.classList.add('on-animate');
					}
				}
			});
		}
	});

	// Recalculate ScrollTrigger when window width changes (debounced)
	let prevWidth = window.innerWidth;
	let resizeTimeout = null;
	window.addEventListener('resize', () => {
		const w = window.innerWidth;
		if (w === prevWidth) return; // only act when width changed
		prevWidth = w;
		if (resizeTimeout) clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			ScrollTrigger.refresh();
			resizeTimeout = null;
		}, 150);
	});

}